// extracted by mini-css-extract-plugin
export default {"summary":"uA","separator":"vA","title":"wA","note":"xA","items_wrapper":"yA","member_perk":"zA","info":"AA","extraQuestionsContain":"BA","h1":"CA","p":"EA","btn":"FA","stickyButton":"GA"};
    if(module.hot) {
      // 1721922364109
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  